import type { RouteRecordRaw } from 'vue-router';

export const quotesRoutes: RouteRecordRaw[] = [
  {
    path: 'quotes',
    name: 'quotes',
    component: () => import('./pages/QuotesListPage.vue'),
    meta: { title: 'Quotes', requiresAuth: true, permission: 'view_quotes' },
  },
  {
    path: 'quotes/new',
    name: 'quotes.create',
    component: () => import('./pages/QuoteEditorPage.vue'),
    meta: { title: 'New quote', requiresAuth: true },
  },
  {
    path: 'quotes/:id',
    name: 'quotes.show',
    component: () => import('./pages/QuoteEditorPage.vue'),
    meta: { title: 'Quote', requiresAuth: true },
  },
];
